import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import * as Sentry from "@sentry/react";

// setup Sentry for error tracking
Sentry.init({
  dsn: "https://ec3faadb4bab7d71e11ebaf0da870cad@o4509434885242880.ingest.de.sentry.io/4509434888061008",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
